"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Category {
    constructor({ id, name, parentCategory }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            parentCategory: this.parentCategory,
        });
        this.id = id;
        this.name = name;
        this.parentCategory = parentCategory;
    }
}
Category.fromJSON = (json) => {
    const { id, name, parentCategory } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    const _parentCategory = typeof parentCategory !== 'undefined' ? Category.fromJSON(parentCategory) : undefined;
    return new Category({
        id,
        name,
        parentCategory: _parentCategory,
    });
};
exports.default = Category;
